export function normalizeZip(value) {
  const clean = String(value).trim();
  return /^\d{5}(?:[- ]?\d{4})?$/.test(clean) ? clean.slice(0, 5) : null;
}
export function calculateDelivery(miles) {
  if (!Number.isFinite(miles) || miles < 0) return null;
  if (miles > 600) return 150000;
  return Math.round(Math.min(1400, 150 + Math.max(0, miles - 60) * 2.5) * 100);
}
export function lookupDelivery(zip, data) {
  const row = data.estimates[zip];
  if (row) return {zone:row[1] === 15000 ? 'local' : 'distance', miles:row[0], cents:row[1]};
  const n = Number(zip);
  const contains = bits => (bits.charCodeAt(Math.floor(n / 8)) & (1 << (n % 8))) !== 0;
  if (contains(data.continentalZipBits)) return {zone:'national', cents:data.nationalFlatCents};
  if (contains(data.excludedZipBits)) return {zone:'excluded', cents:null};
  return {zone:contains(data.knownZipBits) ? 'quote' : 'unknown', cents:null};
}
const dataRequests = new Map();
async function loadData(url) {
  if (!dataRequests.has(url)) {
    const request = fetch(url).then(response => {
      if (!response.ok) throw new Error('Delivery data unavailable');
      return response.json();
    }).then(data => {
      if (data.schema !== 2 || data.radiusMiles !== 600 || data.nationalFlatCents !== 150000 || !data.estimates || !data.knownZipBitsBase64 || !data.continentalZipBitsBase64 || !data.excludedZipBitsBase64) throw new Error('Unsupported delivery data');
      data.knownZipBits = atob(data.knownZipBitsBase64);data.continentalZipBits = atob(data.continentalZipBitsBase64);data.excludedZipBits = atob(data.excludedZipBitsBase64);return data;
    }).catch(error => {dataRequests.delete(url);throw error;});
    dataRequests.set(url, request);
  }
  return dataRequests.get(url);
}
if (typeof document !== 'undefined') {
  const states = new WeakMap(), storageKey = 'ghm-delivery-zip-v1';
  const money = new Intl.NumberFormat('en-US',{style:'currency',currency:'USD'});
  const distance = new Intl.NumberFormat('en-US',{maximumFractionDigits:1});
  const readZip=()=>{try{return normalizeZip(sessionStorage.getItem(storageKey)||'');}catch{return null;}};
  const writeZip=zip=>{try{sessionStorage.setItem(storageKey,zip);}catch{ /* Estimate works without storage. */ }};
  function initialize(root) {
    const form=root.querySelector('[data-delivery-form]');
    if (!form || states.get(root)?.form===form) return;
    const input=form.querySelector('[data-delivery-zip]'), button=form.querySelector('[data-delivery-submit]');
    const amount=root.querySelector('[data-delivery-amount]'), zone=root.querySelector('[data-delivery-zone]'), detail=root.querySelector('[data-delivery-detail]');
    const labels=JSON.parse(root.querySelector('[data-delivery-labels]').textContent);let sequence=0;
    function busy(value){button.disabled=value;button.textContent=value?labels.loading:labels.submit;root.setAttribute('aria-busy',String(value));}
    function message(value,caption,description){amount.textContent=value;zone.textContent=caption;detail.textContent=description;amount.classList.add('is-quote');}
    async function estimate(zip){
      const current=++sequence;input.value=zip;input.setAttribute('aria-invalid','false');busy(true);message(labels.loading_amount,'','');
      try{
        const data=await loadData(root.dataset.deliveryDataUrl);if(current!==sequence)return;
        const result=lookupDelivery(zip,data);
        amount.textContent=result.cents===null?(result.zone==='excluded'?labels.excluded_amount:labels.quote_amount):money.format(result.cents/100);amount.classList.toggle('is-quote',result.cents===null);zone.textContent=labels[result.zone+'_label'];
        detail.textContent=labels[result.zone+'_detail'].replaceAll('__ZIP__',zip).replaceAll('__MILES__',result.miles===undefined?'':distance.format(result.miles));
      }catch{if(current===sequence)message(labels.quote_amount,labels.quote_label,labels.unavailable_detail);}
      finally{if(current===sequence)busy(false);}
    }
    states.set(root,{form,estimate});
    form.addEventListener('submit',event=>{
      event.preventDefault();const zip=normalizeZip(input.value);
      if(!zip){sequence++;busy(false);input.setAttribute('aria-invalid','true');message(labels.invalid_amount,'',labels.invalid_detail);input.focus();return;}
      writeZip(zip);document.dispatchEvent(new CustomEvent('ghm:delivery-zip',{detail:{zip}}));
    });
    input.addEventListener('input',()=>{sequence++;busy(false);input.removeAttribute('aria-invalid');message(labels.idle_amount,'',labels.idle_detail);});
    root.querySelector('[data-delivery-ui]').hidden=false;const previous=readZip();if(previous)estimate(previous);
  }
  function init(scope){
    if(scope.nodeType!==1&&scope.nodeType!==9)return;
    if(scope.matches?.('[data-ghm-delivery-calculator]'))initialize(scope);
    scope.querySelectorAll('[data-ghm-delivery-calculator]').forEach(initialize);
  }
  document.addEventListener('ghm:delivery-zip',event=>{document.querySelectorAll('[data-ghm-delivery-calculator]').forEach(root=>states.get(root)?.estimate(event.detail.zip));});
  function start(){
    init(document);
    new MutationObserver(changes=>changes.forEach(change=>change.addedNodes.forEach(node=>{
      if(node.nodeType!==1)return;init(node);const root=node.closest('[data-ghm-delivery-calculator]');if(root)initialize(root);
    }))).observe(document.body,{subtree:true,childList:true});
  }
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',start,{once:true});else start();
  document.addEventListener('shopify:section:load',event=>init(event.target));
}
